import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import useIsMobile from '../../hooks/useIsMobile';

const ResponsiveModal = ({
  isOpen,
  onClose,
  children,
  className = '',
  /** Overlay z-index (nested modals must be above parent, e.g. z-[10050] when opened inside TicketDetailModal z-[9999]) */
  overlayClassName = 'z-[1000]',
  /** If false, clicking the backdrop does not close (e.g. long forms; use explicit close button). */
  closeOnBackdropClick = true,
}) => {
  const isMobile = useIsMobile();
  const pointerStartedOnBackdrop = useRef(false);

  if (!isOpen) return null;

  const handleBackdropMouseDown = (event) => {
    pointerStartedOnBackdrop.current = event.target === event.currentTarget;
  };

  const handleBackdropClick = (event) => {
    if (
      closeOnBackdropClick
      && pointerStartedOnBackdrop.current
      && event.target === event.currentTarget
    ) {
      onClose();
    }
    pointerStartedOnBackdrop.current = false;
  };

  return createPortal(
    <div
      className={`fixed inset-0 bg-black/50 backdrop-blur-sm ${overlayClassName}`}
      onMouseDown={closeOnBackdropClick ? handleBackdropMouseDown : undefined}
      onClick={closeOnBackdropClick ? handleBackdropClick : undefined}
      role="presentation"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`absolute flex min-w-0 flex-col overflow-hidden bg-white shadow-2xl dark:bg-gray-800 ${
          isMobile
            ? 'inset-x-0 bottom-0 max-h-[92dvh] rounded-t-2xl'
            : 'left-1/2 top-1/2 max-h-[90vh] w-full max-w-3xl -translate-x-1/2 -translate-y-1/2 rounded-2xl'
        } ${className}`}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};

export default ResponsiveModal;
